import React, { useState, useRef, useEffect } from "react";
import { SendHorizontal, User, Pill } from "lucide-react";
import Navbar from "./Navbar";
import axios from "axios";
import {API_URL,FAST_API_URL} from "../api"

const MedicineChatbot = () => {
  const [messages, setMessages] = useState([
    {
      0: {
        from: "bot",
        text: "👋 Hi! I'm your Medicine Assistant. Ask me anything about medicines or health-related queries!",
      },
      1: {
        from: "bot",
        text: "👋 नमस्ते! मैं आपकी दवा सहायक हूँ। दवाओं या स्वास्थ्य से संबंधित किसी भी प्रश्न के लिए मुझसे पूछें!"
      },
      2: {

      from: "bot",
        text: "👋 ਸਤ ਸ੍ਰੀ ਅਕਾਲ! ਮੈਂ ਤੁਹਾਡਾ ਦਵਾਈ ਸਹਾਇਕ ਹਾਂ। ਦਵਾਈਆਂ ਜਾਂ ਸਿਹਤ ਸੰਬੰਧੀ ਕਿਸੇ ਵੀ ਸਵਾਲ ਲਈ ਮੈਨੂੰ ਪੁੱਛੋ!"
      }
    }
  ]);
  const [input, setInput] = useState("");
  const [isTyping, setIsTyping] = useState(false);
  const chatEndRef = useRef(null);
  const [chat_history, setchat_history] = useState("{}");

  const handleSend = async () => {
    const lang = localStorage.getItem("lang");
    if (!input.trim()) return;

    setMessages((prev) => [...prev, {
      [lang]: {
        from: "user",
        text: input.trim(),
      },
    }]);
    setInput("");
    setIsTyping(true);

    try {
      const res = await axios.post(`${FAST_API_URL}/api/medicine_chat`, {
        message: input,
        session_id: localStorage.getItem("nurse_session_id") || null,
        history: chat_history,
        lang: localStorage.getItem("lang_name")
      },
        { headers: { "Content-Type": "application/json" } }
      );

      const {
        session_id,
        response: botResponse,
        history_user: updatedChatHistoryFromAPI,
      } = res.data;

      setchat_history(updatedChatHistoryFromAPI);
      localStorage.setItem("nurse_session_id", session_id);
      const lang = localStorage.getItem("lang");

      setMessages((prev) => [
        ...prev,
        {
          [lang]: {
            from: "bot",
            text: `💊 ${botResponse}`,
          },
        },
      ]);
    } catch (err) {
      console.error(err);
      setMessages((prev) => [
        ...prev,
        
        {
          [lang]: {
            from: "bot",
            text: "⚠️ Failed to get response.",
          },
        },
      ]);
    }

    setIsTyping(false);
  };

  useEffect(() => {
    chatEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages, isTyping]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-teal-500 via-green-400 to-blue-300">
      <Navbar />

      <div className="flex justify-center items-center px-4 py-6">
        <div className="w-full max-w-3xl h-[85vh] bg-white/70 backdrop-blur-lg rounded-3xl shadow-xl flex flex-col overflow-hidden border border-white/30">
          {/* Header */}
          <div className="bg-gradient-to-br from-teal-500 via-green-400 to-blue-300 w-full h-[70px] flex items-center px-6 shadow-md">
            <Pill className="text-white w-6 h-6 mr-3" />
            <h2 className="text-white text-xl md:text-2xl font-semibold tracking-wide">
              Medicine Chatbot
            </h2>
          </div>

          {/* Chat Area */}
          <div className="flex-1 overflow-y-auto px-5 py-6 space-y-6">
            {console.log(messages)}
            {messages.map((msg, i) => (
              
              <div
                key={i}
                className={`flex ${msg[localStorage.getItem("lang")].from === "user" ? "justify-end" : "justify-start"}`}
              >
                {console.log(msg)}
                <div className="flex items-end gap-3 max-w-full">
                
                  {msg[localStorage.getItem("lang")].from === "bot" && (
                    <div className="bg-teal-500 p-2 rounded-full shadow-md">
                      <Pill className="text-white w-4 h-4" />
                    </div>
                  )}
                  <div
                    className={`max-w-[75%] px-5 py-3 text-sm leading-relaxed shadow-md rounded-2xl ${msg[localStorage.getItem("lang")].from === "bot"
                        ? "bg-white text-gray-800 rounded-bl-sm"
                        : "bg-indigo-600 text-white rounded-br-sm"
                      }`}
                  >
                    {msg[localStorage.getItem("lang")].text}
                  </div>
                  {msg[localStorage.getItem("lang")].from === "user" && (
                    <div className="bg-indigo-600 p-2 rounded-full shadow-md">
                      <User className="text-white w-4 h-4" />
                    </div>
                  )}
                </div>
              </div>
            ))}

            {/* Typing Indicator */}
            {isTyping && (
              <div className="flex items-center gap-2 text-sm text-gray-600">
                <Pill className="text-teal-500 w-4 h-4" />
                <div className="flex gap-1">
                  <span className="w-2 h-2 bg-gray-400 rounded-full animate-bounce" />
                  <span className="w-2 h-2 bg-gray-400 rounded-full animate-bounce delay-100" />
                  <span className="w-2 h-2 bg-gray-400 rounded-full animate-bounce delay-200" />
                </div>
              </div>
            )}
            <div ref={chatEndRef} />
          </div>

          {/* Input Area */}
          <div className="px-6 py-4 bg-white/90 border-t border-gray-200 shadow-inner">
            <div className="flex items-center gap-3">
              <input
                type="text"
                placeholder="Ask me something..."
                value={input}
                onChange={(e) => setInput(e.target.value)}
                onKeyDown={(e) => e.key === "Enter" && handleSend()}
                className="flex-1 px-5 py-3 rounded-full border border-gray-300 focus:outline-none focus:ring-2 focus:ring-teal-500 text-sm shadow-sm placeholder:text-gray-400 bg-white"
              />
              <button
                onClick={handleSend}
                className="p-3 bg-teal-600 hover:bg-teal-700 text-white rounded-full shadow-md transition hover:scale-105"
              >
                <SendHorizontal className="w-5 h-5" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MedicineChatbot;
